var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconParkOutlinePeople = function SvgIconParkOutlinePeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-1ym952v",
    focusable: "false",
    style: {
      fill: "none"
    },
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 8.444a2.722 2.722 0 1 0 0-5.443 2.722 2.722 0 0 0 0 5.443m-7 8.09V17h14v-.467c0-1.742 0-2.613-.34-3.279a3.1 3.1 0 0 0-1.359-1.36c-.665-.338-1.537-.338-3.279-.338H7.978c-1.742 0-2.614 0-3.28.339a3.1 3.1 0 0 0-1.359 1.36C3 13.92 3 14.79 3 16.532"
  })));
};
export default SvgIconParkOutlinePeople;